module.exports = __webpack_public_path__ + "static/media/Show.72792a11.svg";